<template>

    <div v-if="status=='completed'" class="w-full flex xl:hidden lg:hidden md:hidden flex-column  relative py-1 xl:py-0 xl:px-8 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-5 width-5 p-4">
            <span class="absolute w-full h-full vertical-align-middle text-2xl text-0 left-0 font-medium top-0 align-items-center text-center">
                <span class="block relative pi pi-check-circle text-2xl text-green-600" style="margin-top:12px"></span>
            </span>
        </div>
        <span class="flex text-3xl font-medium text-900 mt-4 mb-3 xl:mb-4">{{ content[lang_].done }}</span>
    </div>

    <div class="w-full flex flex-column xl:flex-row relative gap-2">
        <div class="w-full flex flex-column max-w-30rem relative
            surface-0 xl:surface-100 lg:surface-100 md:surface-100 
            border-round-2xl 
            p-3 xl:px-4">
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].sender }}:
            </span>
            <span v-if="sender_amount && sender_currency_code" class="flex text-2xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ get_format_amount(sender_amount, sender_currency_code) }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(sender_amount)"></span>
            </span>
            <span v-if="sender_fullname" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].sender_fullname }}: <span class="font-medium text-900 ml-1">{{ sender_fullname }}</span>
            </span>
            <span v-if="sender_bank_title" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].sender_bank }}: <span class="font-medium text-900 ml-1">{{ sender_bank_title }}</span>
            </span>
            <span v-if="rate" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].rate }}: <span class="font-medium text-900 ml-1">{{ rate }}</span> 
                <span class="ml-2 pi pi-info-circle text-500 cursor-pointer" @click="show_info()"></span>
            </span>
            <span v-if="sender_description" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].description }}: <span class="font-medium text-900 ml-1">{{ sender_description }}</span>
            </span>
            <div class="w-full flex surface-400 my-2" style="height:1px"></div>
            <br>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].recipient }}:
            </span>
            <span v-if="recipient_amount && recipient_currency_code" class="flex text-2xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                {{ get_format_amount(recipient_amount, recipient_currency_code) }}
            </span>
            <span v-if="recipient_fullname" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].recipient_fullname }}: <span class="font-medium text-900 ml-1">{{ recipient_fullname }}</span>
            </span>
            <span v-if="recipient_bank_title" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].recipient_bank }}: <span class="font-medium text-900 ml-1">{{ recipient_bank_title }}</span>
            </span>
            <span v-if="recipient_phone_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].phone_number }}: <span class="font-medium text-900 ml-1">{{recipient_phone_number}}</span>
            </span>
            <span v-if="recipient_account_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].account_number }}: <span class="font-medium text-900 ml-1">{{recipient_account_number}}</span>
            </span>
            <span v-if="recipient_card_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].card_number }}: <span class="font-medium text-900 ml-1">{{format_card(recipient_card_number)}}</span>
            </span>
            <span v-if="recipient_wallet_address" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].wallet_address }}: <span class="font-medium text-900 ml-1">{{recipient_wallet_address}}</span>
            </span>
            <span v-if="recipient_telegram" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].telegram }}: <span class="font-medium text-900 ml-1">{{recipient_telegram}}</span>
            </span>
            <span v-if="recipient_wallet_network" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].wallet_network }}: <span class="font-medium text-900 ml-1">{{recipient_wallet_network}}</span>
            </span>
            <span v-if="recipient_upi_id" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].recipient_upi_id }}: <span class="font-medium text-900 ml-1">{{recipient_upi_id}}</span>
            </span>
            <span v-if="recipient_description" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].description }}: <span class="font-medium text-900 ml-1">{{ recipient_description }}</span>
            </span>
            <div v-if="sender_bank_image" class="absolute flex deep_white_shadow right-0 top-0 surface-0 mr-3 mt-3 border-circle align-items-center justify-content-center text-center">
                <Avatar :image="sender_bank_image" size="medium" shape="circle" class="flex" />
            </div>
            <div v-if="recipient_bank_image" class="absolute flex deep_white_shadow right-0 bottom-0 surface-0 mr-3 mb-3 border-circle align-items-center justify-content-center text-center">
                <Avatar :image="recipient_bank_image" size="medium" shape="circle" class="flex" />
            </div>

            <OverlayPanel ref="info" class="max-w-20rem ml-2 mr-2">
                {{ content[lang_].rate_description }}
            </OverlayPanel>

        </div>

        <div v-if="status=='created'" class="w-full flex flex-column gap-2 max-w-30rem relative py-0 xl:py-0 xl:px-8">
            <InlineMessage severity="warn" class="border-round-2xl line-height-2 text-xs xl:text-md border-none" >
                <span class="line-height-2 text-xs xl:text-md lg:text-sm">{{ content[lang_].make_sure_1 }}</span>
            </InlineMessage>
            <InlineMessage severity="warn" class="border-round-2xl line-height-2 text-xs xl:text-md border-none" >
                <span class="line-height-2 text-xs xl:text-md lg:text-sm">{{ content[lang_].make_sure_2 }} </span>
            </InlineMessage>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import Helper from '@/assets/js/Helper'
export default {
    props: [
        'sender_fullname',
        'sender_amount',
        'sender_currency_code',
        'sender_bank_code',
        'sender_bank_image',
        'sender_bank_title',
        'sender_description',
        'recipient_amount',
        'recipient_currency_code',
        'rate',
        'recipient_fullname',
        'recipient_bank_code',
        'recipient_bank_image',
        'recipient_bank_title',
        'recipient_phone_number',
        'recipient_account_number',
        'recipient_card_number',
        'recipient_wallet_address',
        'recipient_wallet_network',
        'recipient_upi_id',
        'recipient_telegram',
        'recipient_description',
        'status'
    ],
	data(){
		return{
			content: {
				en: {
					sender: "To send",
                    sender_fullname: "Sender name",
                    sender_bank: "Sender bank",
					rate: "Final rate",
                    description: 'Description',
					recipient: "To receive",
					recipient_fullname: 'Recipient name',
                    recipient_bank: 'Recipient bank',
                    phone_number: 'Phone number',
                    account_number: 'Account number',
                    card_number: 'Card number',
                    wallet_address: 'Wallet address',
                    wallet_network: 'Wallet network',
                    recipient_upi_id: 'UPI ID',
                    rate_description: 'Within 15 minutes from the moment of creating the transfer, the exchange rate will not change. In case of non-payment, the transfer will be automatically closed after 15 minutes.',
                    make_sure_1: 'Make sure you are paying from the specified sender name. The sender name must match the name in the bank statement.',
                    make_sure_2: 'Make sure the recipient name matches the name in the bank. Also check the account number, which must start with a number other than zero.',
                    done: 'Transfer completed',
                    copied: 'Copied',
                    telegram: 'Telegram',
				} ,
				ru: {
					sender: "К отправке",
                    sender_fullname: "Имя отправителя",
                    sender_bank: "Банк отправителя",
					rate: "Итоговый курс",
                    description: 'Описание',
					recipient: "К получению",
					recipient_fullname: 'Имя получателя',
                    recipient_bank: 'Банк получателя',
                    phone_number: 'Номер телефона',
                    account_number: 'Номер счета',
                    card_number: 'Номер карты',
                    wallet_address: 'Адрес кошелька',
                    wallet_network: 'Сеть кошелька',
                    recipient_upi_id: 'UPI ID',
                    rate_description: 'В течение 15 минут с момента создания перевода курс обмена не изменится. В случае неоплаты перевод автоматически закроется через 15 минут.',
                    make_sure_1: 'Убедитесь, что вы оплачиваете с указанного имени отправителя. Имя отправителя должно совпадать с именем в чеке банка.',
                    make_sure_2: 'Убедитесь, что имя получателя совпадает с именем в банке. Так же проверьте номер счета, который должен начинаться с цифры отличной от нуля.',
                    done: 'Перевод выполнен',
                    copied: 'Скопировано',
                    telegram: 'Telegram',
				},
			}, 
            info: ref(),
            isTgApp: false,
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
        isTgApp: function () { return this.$store.getters.StateTgApp },
	},
	methods: {
        show_info(){
            this.$refs.info.toggle(event)
        },
        copy(text){
            const format = this.helper.format_amount(text, null, 0)
            this.helper.copy_clipboard(format)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: format, life: 1000 })
        },
        get_format_amount(value, currency) {
            let digits = 2
            if(currency=='rub' || currency=='idr') digits = 0
            return this.helper.format_amount(value, currency, digits)
        },
        phone_mask(phone, cur){
            return this.helper.phone_mask(phone, cur)
        },
        format_card(number){
            return this.helper.format_card(number)
        },
	},
	async beforeCreate() {
        this.helper = new Helper()
	}
}
</script>